import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import Editor from '../editor';
import EditImage from '../edit-image';
import SongUpload from '../song-upload';

const MIN_SONGS = 5;
const ADMIN_LABEL = 'Upload Songs:';
const CLIENT_LABEL = `Upload at least ${MIN_SONGS} songs (No limit to number of songs uploaded):`;

@inject('artistStore', 'userStore', 'songsStore', 'formStore')
@observer
class AuditionForm extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			content: ''
		};
	}

	componentDidMount () {
		document.addEventListener('keypress', this.onKeyPress);
	}

	componentWillUnmount () {
		document.removeEventListener('keypress', this.onKeyPress);
	}

	render () {
		const {
			artistStore,
			userStore,
			songsStore,
			handleImageCrop,
			onNextClick,
			onPrevClick,
			onSubmitClick,
			handleCloseModal,
			adminMode
		} = this.props;

		const { uploadSongs = [] } = artistStore.data.artist.toPOJO();
		const songUploadCellClass = uploadSongs.length === 0 ? '' : 'small-6';

		return (
			<div style={{backgroundColor: 'black'}}>
				<div className="grid-x grid-padding-x">
					<div className="cell small-12 padding-bottom-0">
						<h5>
							{
								_.isEmpty(artistStore.data.artist.get('name')) ?
									'Your Bio:' : `Your Bio: Tell us about ${artistStore.data.artist.get('name')}`
							}
						</h5>
					</div>

					<div className="cell">
						<Editor
							onBlur={ this.onBioBlur }
							onChange={ this.onBioChange }
							content={ this.state.content } />
					</div>
				</div>

				<div className="grid-x grid-padding-x grid-padding-y">
					<div className="cell small-12 padding-bottom-0">
						<h5>Upload Your Band/Artist Photo:</h5>
					</div>

					<div className="cell small-12">
						<EditImage
							fullWidth
							preventRepload
							store={ userStore }
							handleImageCrop={ handleImageCrop }
						 />
					</div>

					<div className="cell small-12 padding-bottom-0">
						<h5>{ adminMode ? ADMIN_LABEL : CLIENT_LABEL }</h5>
					</div>

					<div className={ `cell ${songUploadCellClass}` }>
						<SongUpload fullWidth onDrop={ this.onDrop } />
					</div>

					{ this.renderSongUploadFooter() }
				</div>
			</div>
		);
	}

	@autobind
	onDrop (files) {
		const { formStore, artistStore } = this.props;
		const existing = artistStore.get('uploadSongs');
		const uploadSongs = _.isObject(existing) ? existing.concat(files) : files;

		formStore.setValidation({
			auditionSongs: uploadSongs.length >= MIN_SONGS
		});

		artistStore.set({
			key: 'uploadSongs',
			value: uploadSongs
		});
	}

	renderSongUploadFooter () {
		const { adminMode, artistStore } = this.props;
		const { uploadSongs = [] } = artistStore.data.artist.toPOJO();

		if (uploadSongs.length === 0) {

			return null;
		}

		const songsLength = uploadSongs.length;
		const message = songsLength >= MIN_SONGS ? songsLength : `${songsLength} of ${MIN_SONGS}`;

		return (
			<div className="cell small-6">
				<p>
					<strong>
						{ message } files selected:
					</strong>
				</p>

				<ul>
					{
						_.map(uploadSongs, ({ name }) => (
							<li key={ name }>{ name }</li>
						))
					}
				</ul>
			</div>
		);
	}

	@autobind
	onBioChange (content) {
		this.setState({ content });
	}

	@autobind
	onBioBlur () {
		const { artistStore, formStore } = this.props;
		const { content } = this.state;
		const rawContent = _.isString(content) ? content.replace(/<\/?[^>]+>/g, '') : '';

		formStore.setValidation({
			auditionBioForm: _.isEmpty(rawContent) !== true
		});

		artistStore.set({
			key: 'artist.bio',
			value: content
		});
	}
}

export default AuditionForm;
